import {AuthoringGuideModelV1} from 'resources/GeneratedModels/AuthoringGuide/AuthoringGuideModel.v1';

import {extensions} from './authoringGuide.extensions';

AuthoringGuideModelV1.extend(extensions);

export {AuthoringGuideModelV1};
